export default "__VITE_PUBLIC_ASSET__553bfa53__"